import React, { useEffect } from "react";
import { MdAddToPhotos, MdFavorite } from "react-icons/md";
import { RiFilePaper2Line, RiVipCrownFill } from "react-icons/ri";
import { GrFavorite } from "react-icons/gr";
import { BiChevronLeft, BiSupport } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useDashboard } from "./Hooks";
import Loading from "../../Components/Loading";
import { logDOM } from "@testing-library/react";
import { useListAds } from "../Ads/Hooks";

const Dashboard = () => {
  const { data, loading } = useDashboard();
  const { data: dataAds, loading: loadingAds } = useListAds();

  if (loading) {
    return <Loading count={2} />;
  }
  return (
    <div id="dashboard">

      <div className="row g-3 mb-3">
        <div className="col-xxl-9 col-lg-12">
          <div className="card h-100">
            <div className="bg-holder bg-card bg-image" style={{}} />
            {/*/.bg-holder*/}
            <div className="card-header z-index-1">
              <h5 className="fw-500 fs-20 mb-1">به صنعتبان خوش آمدید!</h5>
              <h6 className="fw-400 fs-15">
                برای دسترسی سریع به لینک های زیر دقت کنید
              </h6>
            </div>
            <div className="card-body z-index-1">
              <div className="row g-2 h-100 align-items-end">
                <div className="col-sm-6 col-md-5 mb-3">
                  <Link to={"/ads-submit"} className="d-flex position-relative">
                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                      <MdAddToPhotos className="color-primary" />
                    </div>
                    <div className="flex-1">
                      <div className="stretched-link">
                        <h6 className="fw-500 fs-12 mb-0">ثبت آگهی</h6>
                      </div>
                      <p className="mb-0 fs-10">
                        آگهی خود را با چند کلیک ساده به اشتراک بزارید
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-sm-6 col-md-5 mb-3">
                  <Link to={"/plans"} className="d-flex position-relative">
                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                      <RiVipCrownFill color="rgb(245, 128, 62)" />
                    </div>
                    <div className="flex-1">
                      <div className="stretched-link" href="#!">
                        <h6 className="fw-500 fs-12 mb-0">خرید اشتراک</h6>
                      </div>
                      <p className="mb-0 fs-10 text-500">
                        برای دسترسی کامل سامانه اشتراک تهیه کنید
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-sm-6 col-md-5 mb-3">
                  <Link to="/book-marks" className="d-flex position-relative">
                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                      <MdFavorite className="color-red" />
                    </div>
                    <div className="flex-1">
                      <a className="stretched-link" href="#!">
                        <h6 className="fw-500 fs-12 mb-0">آکهی ها مرتبط</h6>
                      </a>
                      <p className="mb-0 fs-10 text-500">
                        مشاهده آگهی بر اساس علاقه شما
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-sm-6 col-md-5 mb-3">
                  <Link to={"/support"} className="d-flex position-relative">
                    <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                      <BiSupport className="color-green " />
                    </div>
                    <div className="flex-1">
                      <a className="stretched-link" href="#!">
                        <h6 className="fw-500 fs-12 mb-0">پشتیبانی</h6>
                      </a>
                      <p className="mb-0 fs-10 text-500">
                        چت آنلاین با پشتیبان
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-md-6">
          <div className="card h-100">
            <div className="card-header d-flex justify-content-between">
              <h5 className="mb-0">پیشرفت پروفایل</h5>
              <Link to={"/profile"} className="btn btn-link btn-sm px-0">
                ویرایش
                <BiChevronLeft />
              </Link>
            </div>
            <div className="card-body">
              <p className="fs-14 color-text-2 fw-400">
                {+data.percent == 0
                  ? "پروفایل شما کامل است."
                  : "تکمیل پروفایل شما، باعث خدمت رسانی بهتر ما میشود "}
                <br />
              </p>
              <div
                className="progress mb-3 mt-3 rounded-pill"
                style={{ height: 6 }}
              >
                <div
                  className="progress-bar bg-progress-gradient rounded-pill mtp"
                  role="progressbar"
                  style={{
                    width: `${+data.percent == 0 ? 100 : 100 - +data.percent}%`,
                  }}
                  aria-valuenow="43.72"
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>
              <p className="mb-0 text-primary">
                {Math.floor(+data.percent == 0 ? 100 : 100 - +data.percent)}{" "}
                درصد تکمیل شده است
              </p>
            </div>
          </div>
        </div>
      </div>
      {data.planStatus == "false" && (
        <div className="row">
          <div className="col-xxl-3 col-md-6">
            <div className="card h-100 p-3">
              <div className="d-flex align-items-center">
                <div className="icon-item icon-item-sm border rounded-3 shadow-none ">
                  <RiVipCrownFill color="rgb(245, 128, 62)" />
                </div>
                <h5 className="fw-500 fs-20 mb-1">خرید اشتراک</h5>
              </div>

              <p className="fw-400 fs-12">
                برای خرید اشتراک و دسترسی کامل به سامانه صنعتبان از لینک زیر
                اقدام کنید
              </p>
              <div className="d-flex justify-content-end">
                <Link to={"/plans"} className="btn btn-link btn-sm px-0">
                  خرید اشتراک
                  <BiChevronLeft />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xxl-3 col-md-6">
            <div className="card h-100 p-3">
              <div className="d-flex align-items-center">
                <div className="icon-item icon-item-sm border rounded-3 shadow-none ">
                  <RiFilePaper2Line size={30} color="rgb(245, 128, 62)" />
                </div>
                <h5 className="fw-500 fs-20 mb-1">آگهی های من</h5>
              </div>

              <p className="fw-400 fs-12 mt-2 mb-1">
                {!loadingAds &&
                  dataAds.data.length > 0
                  ?
                  <span>
                    تعداد آگهی های شما : {dataAds.data.length}
                  </span>
                  :
                  <span>شما هنوز هیچ آگهی ثبت نکرده اید</span>
                }


              </p>
              <div className="d-flex justify-content-end">

                {!loadingAds && dataAds.data.length > 0
                  ?
                  <Link to={"/my-ads"} className="btn btn-link btn-sm px-0">
                    نمایش همه‌ی آگهی ها
                    <BiChevronLeft />
                  </Link>
                  :
                  <Link to={"/ads-submit"} className="btn btn-link btn-sm px-0">
                    ثبت آگهی
                    <BiChevronLeft />
                  </Link>
                }


              </div>
            </div>
          </div>


        </div>
      )}
    </div>
  );
};

export default Dashboard;
